import React, { useState } from 'react';
import useLazyQuery from '../../../../../../../users/hooks/useLazyQuery'; // Use from users because other params (to be fixed)

import linkIcon from '../../../../../../assets/img/link-horizontal.svg';

import styles from './BasicSettings.module.css';

import Dropdown from '../../../Dropdown/Dropdown';

import {
  licenceCreditsMapping,
  licenceTypes
} from '../../../../helpers/constants';

import {
  GET_INVITATION_LINK,
  GET_CLIENT_ACCOUNTS_TO_INVITE
} from '../../../../../../graphql/AccountManagement';

export default ({
  level,
  subtitle1,
  subtitle2,
  label1,
  inviteText,
  internalRecord,
  setInternalRecord,
  activePopup,
  invitationParent,
  invitationType,
  parentWithLicence
}) => {
  const [linkCopied, setLinkCopied] = useState(false);
  const [invitationLink, setInvitationLink] = useState(null);

  const getInvitationLink = useLazyQuery(GET_INVITATION_LINK, {
    fetchPolicy: 'no-cache'
  });

  const getClientAccountsToInvite = useLazyQuery(
    GET_CLIENT_ACCOUNTS_TO_INVITE,
    {
      fetchPolicy: 'no-cache'
    }
  );

  const copyLinkToClipboard = () => {
    if (invitationLink) {
      const dummy = document.createElement('input');
      // dummy.style.display = 'none';
      document.body.appendChild(dummy);

      dummy.setAttribute('id', 'goalurl');
      document.getElementById('goalurl').value = invitationLink;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    }
  };

  const onSelectClientCompleted = record => {
    let newMembers = [];

    if (
      internalRecord &&
      internalRecord.managers &&
      internalRecord.managers.length
    ) {
      newMembers = [...internalRecord.managers];
    }

    if (
      !internalRecord.managers ||
      !internalRecord.managers.some(mng => mng.id === record.value)
    ) {
      // Check if already selected
      const newRecord = {
        id: record.value,
        email: record.label
      };

      setInternalRecord({
        ...internalRecord,
        managers: [...newMembers, newRecord]
      });
    } else {
      const filteredSelectedRecords = internalRecord.managers.filter(
        mng => mng.id !== record.value
      );

      setInternalRecord({
        ...internalRecord,
        managers: filteredSelectedRecords
      });
    }
  };

  const fetchClientOptions = async (page, search) => {
    const clientsToInvite = await getClientAccountsToInvite({
      variables: {
        start: 0,
        end: (page + 1) * 10,
        search
      }
    });

    if (
      clientsToInvite &&
      clientsToInvite.data &&
      clientsToInvite.data.getClientAccountsToInvite &&
      clientsToInvite.data.getClientAccountsToInvite.clients &&
      clientsToInvite.data.getClientAccountsToInvite.clients.length
    ) {
      return clientsToInvite.data.getClientAccountsToInvite.clients.map(c => ({
        label: c.email,
        value: c.id
      }));
    }
    return [];
  };

  return (
    <div className={styles.content}>
      {subtitle1 ? (
        <>
          <div className={styles.subtitle}>{subtitle1}</div>
          <input
            className={styles.input}
            placeholder="Enter name"
            value={
              internalRecord && internalRecord.name ? internalRecord.name : ''
            }
            onChange={e =>
              setInternalRecord({
                ...internalRecord,
                name: e.target.value
              })
            }
          />
        </>
      ) : null}

      {level === 1 ? (
        <>
          <div className={styles.dropdownLicenceTopContainer}>
            <div
              className={`${styles.dropdownContainer} ${
                styles.dropdownLicenceContainer
              }`}
            >
              <div className={styles.subtitle}>License</div>
              <Dropdown
                customPlaceholder="Select licence"
                onSelectCompleted={licence => {
                  const newInternalRecord = { ...internalRecord };
                  if (licence && newInternalRecord.licence !== licence) {
                    newInternalRecord.licence = licence.value;
                    newInternalRecord.creditsAllocated =
                      licenceCreditsMapping[licence.value];
                    newInternalRecord.creditsLeft =
                      licenceCreditsMapping[licence.value];

                    if (newInternalRecord.licence === null) {
                      newInternalRecord.nextLicence = null;
                    }
                  }

                  setInternalRecord(newInternalRecord);
                }}
                fetchOptions={() => {
                  const licenceOptions = Object.keys(licenceTypes).map(l => {
                    const capitalised = `${l[0].toUpperCase()}${l
                      .slice(1)
                      .toLowerCase()}`;
                    return {
                      value: l,
                      label: capitalised.replaceAll('_', ' ')
                    };
                  });

                  return [
                    {
                      value: null,
                      label: 'No license'
                    },
                    ...licenceOptions
                  ];
                }}
                loading={false}
                selectedValues={
                  internalRecord && internalRecord.licence
                    ? [
                        {
                          label: `${internalRecord.licence[0].toUpperCase()}${internalRecord.licence
                            .slice(1)
                            .toLowerCase()}`.replaceAll('_', ' '),
                          value: internalRecord.licence
                        }
                      ]
                    : [
                        {
                          value: null,
                          label: 'No license'
                        }
                      ]
                }
                customContainerStyle={styles.licenceDropdownContainer}
              />
            </div>
            {internalRecord && internalRecord.nextLicence ? (
              <div
                className={`${styles.dropdownContainer} ${
                  styles.dropdownLicenceContainer
                }`}
              >
                <div className={styles.subtitle}>New license</div>
                <Dropdown
                  customPlaceholder="Select licence"
                  onSelectCompleted={nextLicence =>
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: nextLicence.value
                    })
                  }
                  fetchOptions={() =>
                    Object.keys(licenceTypes).map(l => {
                      const capitalised = `${l[0].toUpperCase()}${l
                        .slice(1)
                        .toLowerCase()}`;
                      return {
                        value: l,
                        label: capitalised.replaceAll('_', ' ')
                      };
                    })
                  }
                  loading={false}
                  selectedValues={
                    internalRecord && internalRecord.nextLicence
                      ? [
                          {
                            label: `${internalRecord.nextLicence[0].toUpperCase()}${internalRecord.nextLicence
                              .slice(1)
                              .toLowerCase()}`.replaceAll('_', ' '),
                            value: internalRecord.nextLicence
                          }
                        ]
                      : []
                  }
                  customContainerStyle={styles.licenceDropdownContainer}
                />
              </div>
            ) : null}
          </div>
          {internalRecord && internalRecord.licence && activePopup ? (
            <div className={styles.additionalOptionCheck}>
              <input
                type="checkbox"
                onChange={() => {
                  if (internalRecord.nextLicence) {
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: null
                    });
                  } else {
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: licenceTypes.ESSENTIAL
                    });
                  }
                }}
                checked={internalRecord && internalRecord.nextLicence}
              />
              Automatically extend licence
            </div>
          ) : null}
        </>
      ) : null}

      {level === 2 && parentWithLicence ? (
        <>
          <div className={styles.additionalOptionCheck}>
            <input
              type="checkbox"
              onChange={() => {
                if (
                  internalRecord.creditsAllocated ||
                  internalRecord.creditsAllocated === 0
                ) {
                  setInternalRecord({
                    ...internalRecord,
                    creditsAllocated: null
                  });
                } else {
                  setInternalRecord({
                    ...internalRecord,
                    creditsAllocated: 0
                  });
                }
              }}
              checked={
                internalRecord &&
                internalRecord.creditsAllocated !== null &&
                internalRecord.creditsAllocated !== undefined
              }
            />
            Allocate credits to this specific team
          </div>
        </>
      ) : null}
      {(level === 1 && internalRecord && internalRecord.licence) ||
      (level === 2 &&
        parentWithLicence &&
        (internalRecord && internalRecord.creditsAllocated !== null) &&
        internalRecord.creditsAllocated !== undefined) ? (
        <div className={styles.creditsLeftTopContainer}>
          <div className={styles.creditsLeftContainer}>
            {label1}
            <input
              className={styles.creditsInput}
              placeholder="0"
              value={internalRecord.creditsAllocated || ''}
              onChange={e => {
                if (e.target.value && e.target.value !== '') {
                  const newAllocatedValue = parseFloat(e.target.value, 10);

                  const newInternalRecord = {
                    ...internalRecord,
                    creditsAllocated: newAllocatedValue
                  };

                  // Create
                  if (!activePopup || !activePopup.record) {
                    newInternalRecord.creditsLeft = newAllocatedValue;
                  }

                  // Update
                  if (activePopup && activePopup.record) {
                    const difference =
                      newAllocatedValue - activePopup.record.creditsAllocated;
                    newInternalRecord.creditsLeft =
                      activePopup.record.creditsLeft + difference;
                  }

                  setInternalRecord(newInternalRecord);
                } else {
                  setInternalRecord({
                    ...internalRecord,
                    creditsAllocated: 0,
                    creditsLeft: 0
                  });
                }
              }}
              onKeyDown={evt =>
                evt.key === 'ArrowDown' ||
                evt.key === 'ArrowUp' ||
                evt.key === 'e' ||
                evt.key === 'E' ||
                evt.key === '-'
                  ? evt.preventDefault()
                  : null
              }
              onWheel={e => e.target.blur()}
              maxLength="6"
              type="number"
              spellCheck
            />
          </div>
          <div className={styles.creditsLeftContainer}>
            Credits left
            <input
              className={styles.creditsInput}
              placeholder="0"
              value={internalRecord.creditsLeft}
              onChange={() => {}}
              disabled
            />
          </div>
        </div>
      ) : null}
      {activePopup ? (
        <>
          <div className={styles.subtitle}>{subtitle2}</div>
          <div className={styles.dropdownContainer}>
            <Dropdown
              customPlaceholder="Select client account(s)"
              onSelectCompleted={onSelectClientCompleted}
              searchEnabled
              fetchOptions={fetchClientOptions}
              loading={false}
              selectedValues={
                internalRecord && internalRecord.managers
                  ? internalRecord.managers
                  : []
              }
              labelField="email"
              valueField="id"
            />
          </div>
        </>
      ) : null}
      <div className={styles.subtitle}>{inviteText}</div>
      {!invitationLink ? (
        <div
          className={styles.copyLinkButton}
          role="presentation"
          onClick={async () => {
            const invitationRecord = invitationParent || internalRecord.id;

            const invitationToken = await getInvitationLink({
              variables: {
                record: invitationRecord,
                invitationType
              }
            });
            if (
              invitationToken &&
              invitationToken.data &&
              invitationToken.data.getInvitationLink &&
              invitationToken.data.getInvitationLink.link
            ) {
              setInvitationLink(invitationToken.data.getInvitationLink.link);
            }
          }}
        >
          <img src={linkIcon} alt="Link icon" className={styles.linkIcon} />
          Generate link
        </div>
      ) : null}
      {invitationLink ? (
        <div className={styles.invitationLinkContainer}>
          <input value={invitationLink || ''} onChange={() => {}} />
          {!linkCopied ? (
            <div
              role="presentation"
              className={styles.copyInputLink}
              onClick={() => {
                copyLinkToClipboard();
                setLinkCopied(true);
              }}
            >
              Copy link
            </div>
          ) : null}
          {linkCopied ? (
            <div className={styles.copiedInputLink}>Copied</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
